import { isEmpty } from 'lodash';

import { createInterpolatedTranslationKey, useTranslate } from '@dreryk/react-common';

import { translationKeys } from '../../../translations';

import { PatientGroup } from './PatientGroupsAssignmentsMultiselect.types';

export const usePatientGroupLabelExtractor = (
   patientGroupsLength: number
): ((patientGroups: PatientGroup[]) => string) => {
   const translate = useTranslate();
   return (selectedPatientGroups) => {
      if (isEmpty(selectedPatientGroups)) {
         return translate(translationKeys.selectGroups);
      }

      return translate(
         createInterpolatedTranslationKey(translationKeys.chosenOf, {
            count: selectedPatientGroups.length,
            totalCount: patientGroupsLength,
         })
      );
   };
};
